<style lang="scss" scoped>
.slide-3 {
  background-image: url("../../../assets/module4/slide3/bg-01.jpg");
  background-position: center;
  background-size: cover;
  padding-top: 80px;
  height: calc(100% - 80px);
  padding-right: 110px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
h1 {
  font-size: 64px;
  line-height: 76px;
  color: #aa252c;
  &.h1 {
    transform: rotate(-3deg);
  }
  &.h2 {
    font-size: 121px;
    line-height: 161px;
  }
  &.h3 {
    color: white;
  }
  &.l {
    color: white;
    font-size: 115px;
    line-height: 139px;
  }
}
p {
  font-size: 34px;
  line-height: 40px;
  max-width: 759px;
  color: white;
  margin-bottom: 50px;
  &:first-of-type {
    margin-top: 40px;
  }
}
</style>

<template>
  <div class="slide-3">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 2"
        src="@/assets/module4/slide3/sophia-01.png"
        class="chars"
      />
    </transition>
    <transition name="fadeUp" appear>
      <div class="delay-1" v-show="slideIndex == 2">
        <h1 class="h1 ">
          {{ $t("module4.slide3.heading1") }}
        </h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <h1 v-show="slideIndex == 2" class="h2 delay-2">
        {{ $t("module4.slide3.heading2") }}
      </h1>
    </transition>
    <transition name="fadeUp" appear>
      <h1 v-show="slideIndex == 2" class="h3 delay-3">
        {{ $t("module4.slide3.heading3") }}
      </h1>
    </transition>
    <transition name="fadeUp" appear>
      <h1 v-show="slideIndex == 2" class="delay-4">
        {{ $t("module4.slide3.heading4") }}
      </h1>
    </transition>
    <transition name="fadeUp" appear>
      <h1 v-show="slideIndex == 2" class="l delay-5">
        {{ $t("module4.slide3.heading5") }}
      </h1>
    </transition>
    <transition name="scale" appear>
      <p class="delay-6" v-show="slideIndex == 2">
        {{ $t("module4.slide3.paragraph1") }}
      </p>
    </transition>
    <transition name="scale" appear>
      <p v-show="slideIndex == 2" class="delay-7">
        {{ $t("module4.slide3.paragraph2") }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
